module.exports = new __parcel__URL__("14834_sq.e427e92c.jpg").toString();